import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
    ADD_NEW_PAYMENT_CONFIGURATION,
    ADD_NEW_PAYMENT_METHOD,
    DELETE_PAYMENT_CONFIGURATION,
    DELETE_PAYMENT_METHOD,
    EDIT_PAYMENT_CONFIGURATION,
    EDIT_PAYMENT_METHOD,
    GET_GENERAL,
    GET_GENERAL_SETTING,
    GET_GENERAL_USE,
    //payment configuration
    GET_PAYMENT_CONFIGURATION_DETAILS,
    GET_PAYMENT_GATEWAY,
    //payment dp
    GET_PAYMENT_LIST,
    //payment method
    GET_PAYMENT_METHOD,
    GET_PAYMENT_METHOD_LIST,
    GET_PAYMENT_TYPE_DROPDOWN,
    GET_STATE,
    GET_STATE_2,
    UPDATE_GENERAL_SETTING,
} from "./actionTypes.js";

import {
    addPaymentConfigurationFail,
    addPaymentConfigurationSuccess,
    addPaymentMethodFail,
    addPaymentMethodSuccess,
    deletePaymentConfiguration,
    deletePaymentConfigurationFail,
    deletePaymentConfigurationSuccess,
    deletePaymentMethodFail,
    deletePaymentMethodSuccess,
    editPaymentConfigurationFail,
    editPaymentConfigurationSuccess,
    editPaymentMethodFail,
    editPaymentMethodSuccess,
    getGeneralFail,
    getGeneralSettingFail,
    getGeneralSettingSuccess,
    getGeneralSuccess,
    getGeneralUseFail,
    getGeneralUseSuccess,
    getPaymentConfigurationDetailsFail,
    //payment configuration
    getPaymentConfigurationDetailsSuccess,
    getPaymentGatewayFail,
    getPaymentGatewaySuccess,
    //payment method
    getPaymentListSuccess,
    getPaymentMethodFail,
    getPaymentMethodListingFail,
    getPaymentMethodListingSuccess,
    //payment method
    getPaymentMethodSuccess,
    getPaymentTypeDropdownFail,
    getPaymentTypeDropdownSuccess,
    getState2Fail,
    getState2Success,
    getStateFail,
    getStateSuccess,
    updateGeneralSettingFail,
    updateGeneralSettingSuccess
} from "./action.js";

import {
    addPaymentConfiguration,
    addPaymentMethod,
    deletePaymentConfigurationApi,
    deletePaymentMethod,
    editPaymentConfiguration,
    editPaymentMethod,
    generalApi,
    generalSettingApi,
    generalUseApi,
    paymenMethodListingApi,
    paymenMethodListingDropDownApi,
    paymentConfigurationApi,
    paymentGateWayDropDownApi,
    //payment dp
    paymentListingApi,
    paymentTypeDropDownApi,
    state2Api,
    stateApi,
    updateGeneralSettingApi,
} from "./generalApi.js";

function* fetchGeneral() {
    try {
        const response = yield call(generalApi)
        yield put(getGeneralSuccess(response))
    } catch (error) {
        yield put(getGeneralFail(error))
    }
}

function* fetchState({ payload: id }) {
    try {
        const response = yield call(stateApi, id)
        yield put(getStateSuccess(response))
    } catch (error) {
        yield put(getStateFail(error))
    }
}

function* fetchState2({ payload: id }) {
    try {
        const response = yield call(state2Api, id)
        yield put(getState2Success(response))
    } catch (error) {
        yield put(getState2Fail(error))
    }
}

function* fetchGeneralSetting() {
    try {
        const response = yield call(generalSettingApi)
        yield put(getGeneralSettingSuccess(response))
    } catch (error) {
        yield put(getGeneralSettingFail(error))
    }
}

function* updateGeneralSetting({ payload: setting }) {
    try {
        const response = yield call(updateGeneralSettingApi, setting)
        yield put(updateGeneralSettingSuccess(response))
    } catch (error) {
        yield put(updateGeneralSettingFail(error))
    }
}

function* fetchGeneralUse() {
    try {
        const response = yield call(generalUseApi)
        yield put(getGeneralUseSuccess(response))
    } catch (error) {
        yield put(getGeneralUseFail(error))
    }
}

//payment method
function* fetchPaymentMethod({ payload: length, sort, page, name }) {
    try {
        const response = yield call(paymenMethodListingDropDownApi, length, sort, page, name)
        yield put(getPaymentMethodSuccess(response))
    } catch (error) {
        yield put(getPaymentMethodFail(error))
    }
}

function* fetchPaymentMethodList({ payload: length, sort, page }) {
    try {
        const response = yield call(paymenMethodListingApi, length, sort, page)
        yield put(getPaymentMethodListingSuccess(response))
    } catch (error) {
        yield put(getPaymentMethodListingFail(error))
    }
}

function* onAddNewPaymentMethod({ payload: paymentMethod }) {
    try {
        const response = yield call(addPaymentMethod, paymentMethod)
        yield put(addPaymentMethodSuccess(response))
    } catch (error) {
        yield put(addPaymentMethodFail(error))
    }
}

function* onEditPaymentMethod({ payload: paymentMethod, id }) {
    try {
        const response = yield call(editPaymentMethod, paymentMethod, id)
        yield put(editPaymentMethodSuccess(response))
    } catch (error) {
        yield put(editPaymentMethodFail(error))
    }
}

function* onDeletePaymentMethod({ payload: id }) {
    try {
        const response = yield call(deletePaymentMethod, id)
        yield put(deletePaymentMethodSuccess(response))
    } catch (error) {
        yield put(deletePaymentMethodFail(error))
    }
}

//payment configuration

function* fetchPaymentConfigurationDetails({ payload: id }) {
    try {
        const response = yield call(paymentConfigurationApi, id)
        yield put(getPaymentConfigurationDetailsSuccess(response))
    } catch (error) {
        yield put(getPaymentConfigurationDetailsFail(error))
    }
}

function* onAddNewPaymentConfiguration({ payload: paymentConfiguration }) {
    try {
        const response = yield call(addPaymentConfiguration, paymentConfiguration)
        yield put(addPaymentConfigurationSuccess(response))
    } catch (error) {
        yield put(addPaymentConfigurationFail(error))
    }
}

function* onEditPaymentConfiguration({ payload: {paymentConfiguration, id} }) {
    try {
        const response = yield call(editPaymentConfiguration, paymentConfiguration, id)
        yield put(editPaymentConfigurationSuccess(response))
    } catch (error) {
        yield put(editPaymentConfigurationFail(error))
    }
}

function* onDeletePaymentConfiguration({ payload: id }) {
    try {
        const response = yield call(deletePaymentConfigurationApi, id)
        yield put(deletePaymentConfigurationSuccess(response))
    } catch (error) {
        yield put(deletePaymentConfigurationFail(error))
    }
}


//payment dp
function* fetchPaymentList({payload: paymentMethod}) {
    try {
        const response = yield call(paymentListingApi, paymentMethod)
        yield put(getPaymentListSuccess(response))
    } catch (error) {
        yield put(getPaymentMethodFail(error))
    }
}

function* fetchPaymentGateway() {
    try {
        const response = yield call(paymentGateWayDropDownApi)
        yield put(getPaymentGatewaySuccess(response))
    } catch (error) {
        yield put(getPaymentGatewayFail(error))
    }
}

function* fetchPaymentTypeDropdown() {
    try {
        const response = yield call(paymentTypeDropDownApi)
        yield put(getPaymentTypeDropdownSuccess(response))
    } catch (error) {
        yield put(getPaymentTypeDropdownFail(error))
    }
}


function* GeneralSaga() {
    yield takeEvery(GET_GENERAL, fetchGeneral)
    yield takeEvery(GET_STATE, fetchState)
    yield takeEvery(GET_STATE_2, fetchState2)
    yield takeEvery(GET_GENERAL_SETTING, fetchGeneralSetting)
    yield takeEvery(UPDATE_GENERAL_SETTING, updateGeneralSetting)
    yield takeEvery(GET_GENERAL_USE, fetchGeneralUse)
    //payment
    yield takeEvery(GET_PAYMENT_METHOD, fetchPaymentMethod)
    yield takeEvery(GET_PAYMENT_METHOD_LIST, fetchPaymentMethodList)
    yield takeEvery(ADD_NEW_PAYMENT_METHOD, onAddNewPaymentMethod)
    yield takeEvery(EDIT_PAYMENT_METHOD, onEditPaymentMethod)
    yield takeEvery(DELETE_PAYMENT_METHOD, onDeletePaymentMethod)
    yield takeEvery(GET_PAYMENT_CONFIGURATION_DETAILS, fetchPaymentConfigurationDetails)
    yield takeEvery(ADD_NEW_PAYMENT_CONFIGURATION, onAddNewPaymentConfiguration)
    yield takeEvery(EDIT_PAYMENT_CONFIGURATION, onEditPaymentConfiguration)
    yield takeEvery(DELETE_PAYMENT_CONFIGURATION, onDeletePaymentConfiguration)
    //payment dp
    yield takeEvery(GET_PAYMENT_LIST, fetchPaymentList)
    yield takeEvery(GET_PAYMENT_GATEWAY, fetchPaymentGateway)
    yield takeEvery(GET_PAYMENT_TYPE_DROPDOWN, fetchPaymentTypeDropdown)

}

export default GeneralSaga
